(function () {
  const productCache = new Map();

  function parsePrice(element) {
    if (!element) return null;

    const value = element.textContent
      .replace(/Rs\.?\s*/i, '')
      .replace(/,/g, '')
      .trim();

    const number = parseFloat(value);

    return Number.isFinite(number)
      ? number
      : null;
  }

  function formatSaving(amount, upTo) {
    const roundedAmount = Math.round(amount);

    return (
      (upTo ? 'Save up to Rs. ' : 'Save Rs. ') +
      roundedAmount.toLocaleString('en-PK')
    );
  }

  function styleBadge(badge) {
    badge.style.width = 'auto';
    badge.style.minWidth = '68px';
    badge.style.height = 'auto';
    badge.style.minHeight = '30px';
    badge.style.padding = '6px 9px';
    badge.style.borderRadius = '999px';
    badge.style.whiteSpace = 'nowrap';
    badge.style.fontSize = '10px';
    badge.style.lineHeight = '1.2';
    badge.style.display = 'inline-flex';
    badge.style.alignItems = 'center';
    badge.style.justifyContent = 'center';
  }

  function applyBadge(badge, amount, upTo) {
    if (
      !badge ||
      !Number.isFinite(amount) ||
      amount <= 0
    ) {
      return;
    }

    const label = formatSaving(
      amount,
      upTo
    );

    if (badge.textContent.trim() !== label) {
      badge.textContent = label;
    }

    badge.setAttribute(
      'data-rupee-savings-badge',
      'true'
    );

    styleBadge(badge);
  }

  function findCollectionBadge(card) {
    const convertedBadge = card.querySelector(
      '[data-rupee-savings-badge]'
    );

    if (convertedBadge) {
      return convertedBadge;
    }

    const elements = card.querySelectorAll('*');

    for (const element of elements) {
      const text = element.textContent.trim();

      if (
        element.children.length === 0 &&
        /^-?\s*\d+\s*%$/.test(text)
      ) {
        return element;
      }
    }

    return null;
  }

  function getVisibleCardSaving(card) {
    const priceContainer =
      card.querySelector(
        '.t4s-product-price[data-pr-prices]'
      ) ||
      card.querySelector('.t4s-product-price');

    if (!priceContainer) return null;

    const compareAtPrice = parsePrice(
      priceContainer.querySelector('del')
    );

    const sellingPrice = parsePrice(
      priceContainer.querySelector('ins')
    );

    if (
      compareAtPrice === null ||
      sellingPrice === null ||
      compareAtPrice <= sellingPrice
    ) {
      return null;
    }

    return {
      amount: compareAtPrice - sellingPrice,
      upTo: false
    };
  }

  function getProductJSONUrl(card) {
    const link = card.querySelector(
      'a[href*="/products/"]'
    );

    if (!link) return null;

    const url = new URL(
      link.href,
      window.location.origin
    );

    url.search = '';
    url.hash = '';

    if (!url.pathname.endsWith('.js')) {
      url.pathname =
        url.pathname.replace(/\/$/, '') +
        '.js';
    }

    return url.toString();
  }

  async function loadProduct(url) {
    if (productCache.has(url)) {
      return productCache.get(url);
    }

    const request = fetch(url, {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });

    productCache.set(url, request);

    return request;
  }

  async function getVariantSaving(card) {
    const productUrl = getProductJSONUrl(card);

    if (!productUrl) return null;

    const product = await loadProduct(
      productUrl
    );

    if (
      !product ||
      !Array.isArray(product.variants)
    ) {
      return null;
    }

    const savings = product.variants
      .map(function (variant) {
        const price = Number(
          variant.price
        );

        const compareAtPrice = Number(
          variant.compare_at_price
        );

        if (
          !Number.isFinite(price) ||
          !Number.isFinite(compareAtPrice) ||
          compareAtPrice <= price
        ) {
          return null;
        }

        return (
          compareAtPrice - price
        ) / 100;
      })
      .filter(function (amount) {
        return (
          Number.isFinite(amount) &&
          amount > 0
        );
      });

    if (!savings.length) return null;

    const uniqueSavings = [
      ...new Set(savings)
    ];

    return {
      amount: Math.max(...savings),
      upTo:
        product.variants.length > 1 ||
        uniqueSavings.length > 1
    };
  }

  async function updateCollectionCard(card) {
    const badge = findCollectionBadge(card);

    if (!badge) return;

    let saving = getVisibleCardSaving(card);

    if (!saving) {
      saving = await getVariantSaving(card);
    }

    if (!saving) return;

    applyBadge(
      badge,
      saving.amount,
      saving.upTo
    );
  }

  function updateCollectionBadges() {
    document
      .querySelectorAll('.t4s-product')
      .forEach(function (card) {
        updateCollectionCard(card);
      });
  }

  function updateProductPageBadges() {
    document
      .querySelectorAll(
        '.t4s-product-price .t4s-badge-price'
      )
      .forEach(function (badge) {
        const priceContainer = badge.closest(
          '.t4s-product-price'
        );

        if (!priceContainer) return;

        const compareAtPrice = parsePrice(
          priceContainer.querySelector('del')
        );

        const sellingPrice = parsePrice(
          priceContainer.querySelector('ins')
        );

        if (
          compareAtPrice === null ||
          sellingPrice === null ||
          compareAtPrice <= sellingPrice
        ) {
          return;
        }

        applyBadge(
          badge,
          compareAtPrice - sellingPrice,
          false
        );
      });
  }

  function updateEverything() {
    updateCollectionBadges();
    updateProductPageBadges();
  }

  function scheduleUpdate() {
    clearTimeout(
      window.rupeeSavingsTimer
    );

    window.rupeeSavingsTimer = setTimeout(
      updateEverything,
      150
    );
  }

  function start() {
    updateEverything();

    new MutationObserver(
      scheduleUpdate
    ).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();
